import * as React from "react"; 

import { clearIndexes } from "./findWithCache";
import { isObject } from "rant-utils";

export function moveArrayElement(a: any[], from: number, to: number) {
	a.splice(to, 0, a.splice(from, 1)[0]);
}

export function replaceElement<T>(a: T[], find: T, replace: T) {
	const index = a.indexOf(find);
	if (index >= 0) {
		a.splice(index, 1, replace);
	}
}

export function indexOf(a: any[], prop: string, val: any) {
    for(var i=0;i<a.length;i++) {
        if (a[i][prop] === val) return i;
    }
    return -1;
}

export function expectArray<T>(a: T | T[]) {
	if (!a) return a as T[];
	if (Array.isArray(a)) return a as T[];
	return [a] as T[];
}

export function first(array: any) {
    if (!array) return undefined;

	if (Array.isArray(array)) {
		if (array.length > 0) return array[0];
		return undefined;
	} else if (isObject(array)) {
		return array;
	}

    return undefined;
}
export function last<T>(array: T | T[]) {
	const a = (array as any);
    if (!a || a.length <= 0) return undefined;
    return a[a.length-1] as T;
}

export function findFirst(a: any[], prop: string, val: any) {
    const index = indexOf(a, prop, val);
    if (index < 0) return null;
    return a[index];
}

export function indexOfID(a: any[], id: any) {
    return indexOf(a, "id", id);
}

export function getByID(a: any[], id: any) {
    const i = indexOfID(a, id);
    if (i >= 0) {
        return a[i];
    } else {
        return null;
    }
}

export function addElement(a: any[], element: any) {
    a.push(element);

    // if had any indexes then need to clear
    // TODO: can be more precise with this and update the indexes to include the new item rather than just wipe them
    clearIndexes(a);
}

export function removeElement(a: any[], element: any) {
    const i = a.indexOf(element);
    if (i >= 0) {
        a.splice(i, 1);
        
        // if had any indexes then need to clear
        // TODO: can be more precise with this and update the indexes to include the new item rather than just wipe them
        clearIndexes(a);
    }
}

export function classNames(a: any[]) {
    var result = [];
    for(var i=0;i<a.length;i++) {
        if (a[i]) result.push(a[i]);
    }
    return result.join(" ");
}

export function renderList<T>(a: T[], typePlural: string, fn: (item: T, i: number) => void) {
    if (a.length > 0) {
        return a.map(fn);
    } else {
        return React.createElement("div", undefined, "There are no " + typePlural + " to display.");
    }
}

export function combine(arr: string[], sep: string) {
	if (!arr || arr.length <= 0) return "";

	const parts = [];
	for(let a of arr) {
		if (a && a.length > 0) parts.push(a);
	}

	if (parts.length > 0) {
		return parts.join(sep);
	} else {
		return "";
	}

}